// file: web/src/lib/supabase/browser.ts
import { createClient } from "@supabase/supabase-js";

const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
const anon = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

// Vi vil feile tydelig i dev/runtime hvis env mangler.
// (I prod/build skal disse normalt alltid være satt.)
if (!url) {
  throw new Error("NEXT_PUBLIC_SUPABASE_URL is missing (check web/.env.local)");
}
if (!/^https?:\/\//.test(url)) {
  throw new Error(
    `NEXT_PUBLIC_SUPABASE_URL is invalid. Must start with http(s)://. Got: ${url}`
  );
}
if (!anon) {
  throw new Error("NEXT_PUBLIC_SUPABASE_ANON_KEY is missing (check web/.env.local)");
}

export const supabaseBrowser = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});